/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateThermoformingInsoleStockDto } from '../../models/create-thermoforming-insole-stock-dto';
import { ThermoformingInsoleStock } from '../../models/thermoforming-insole-stock';

export interface CreateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params {
      body: CreateThermoformingInsoleStockDto
}

export function createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsoleStock>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingInsoleStock>;
    })
  );
}

createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock.PATH = '/api/mgmt/thermoforming-insole-stock';
